import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";

import { CLink, CFontIcon } from "@appcues/component-library";

import { USER_PROFILE_MODAL } from "constants/globals";
import { fetchUserProfile } from "actions/userProfiles";
import { selectAccountUserProfile } from "reducers/account/userProfiles";
import { showModal } from "actions/currentModal";

export class UserSampleTableUserCell extends Component {
  static propTypes = {
    userId: PropTypes.string.isRequired,
    userProfile: PropTypes.object,
    profileAttributeColumn: PropTypes.string,
    actions: PropTypes.shape({
      fetchUserProfile: PropTypes.func,
      showModal: PropTypes.func
    })
  };

  static defaultProps = {
    userProfile: {},
    profileAttributeColumn: "user_id"
  };

  componentDidMount() {
    const {
      userId,
      actions: { fetchUserProfile }
    } = this.props;
    fetchUserProfile(userId);
  }

  onClickUserId = () => {
    const {
      userProfile,
      actions: { showModal }
    } = this.props;

    showModal(USER_PROFILE_MODAL, {
      userProfile
    });
  };

  getUserIdentifier = () => {
    const { userId, userProfile, profileAttributeColumn } = this.props;
    const userAttribute = userProfile && userProfile[profileAttributeColumn];
    if (userAttribute === null || typeof userAttribute === "boolean") {
      return `${userAttribute}`;
    }

    if (typeof userAttribute === "object") {
      return userId;
    }

    return userAttribute || userId;
  };

  render() {
    const userIdentifier = this.getUserIdentifier();
    return (
      <CLink onClick={this.onClickUserId} id="user-profile-link">
        <CFontIcon
          className="fa fa-user-circle"
          color="unset"
          marginRight={12}
          altText="Click to show user profile modal"
        />
        {userIdentifier}
      </CLink>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    userProfile: selectAccountUserProfile(state, ownProps.userId)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        fetchUserProfile,
        showModal
      },
      dispatch
    )
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserSampleTableUserCell);
